<template>
  <div class="repertorio-detalhes">
    <v-container align-center justify-center class="container">
      <Card v-if="repertorio !== undefined && fail === false"
        v-bind:title="repertorio.nome"
        v-bind:text="repertorio.artista"
        v-bind:subtext="'Arranjo por '+repertorio.arranjador">
        <v-btn v-if="repertorio.linkDrive" color="primary" v-on:click.native="openDrive"><v-icon left>mdi-google-drive</v-icon>Abrir no Google Drive</v-btn>
        <div style="margin-top: 20px">
          <b v-if="repertorio.cantado">Este arranjo já foi cantado</b>
          <b v-if="!repertorio.cantado">Este arranjo não foi cantado</b>
        </div>
        <div v-if="repertorio.midias" style="margin-top: 20px">
          <v-divider></v-divider>
          <h3>Vídeos e gravações</h3>
          <a v-for="midia in repertorio.midias" v-bind:key="midia.key" v-bind:href="midia.link" target="_blank">{{midia.nome}}<br/></a>
        </div>
        <v-speed-dial
      v-model="fab"
      fixed right bottom
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          color="blue darken-2"
          dark
          fab
        >
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-btn
        fab
        dark
        small
        color="green"
        v-on:click.native="editar"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        fab
        dark
        small
        color="red"
        @click.stop="deleteConfirm = true"
      >
        <v-icon>mdi-delete</v-icon>
      </v-btn>
    </v-speed-dial>
      </Card>
      <Card v-if="fail === true"
        title="Erro"
        color="red">
        Não foi possível encontrar este arranjo
      </Card>
    </v-container>

    <v-dialog v-model="deleteConfirm" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">Apagar Arranjo</v-card-title>
        <v-card-text>Tem certeza que deseja apagar este arranjo? Esta operação é irreversível.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" text @click="deleteConfirm = false">Cancelar</v-btn>
          <v-btn color="red darken-1" text @click="deletar">Apagar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import Card from '@/components/Card.vue'
import { db } from '../main'

export default {
  name: 'detalhesrepertorio',
  components: {
    Card
  },
  props: ['repertorioid'],
  data () {
    return {
      repertorio: undefined,
      boundquery: [],
      fail: false,
      deleteConfirm: false,
      fab: false
    }
  },
  methods: {
    editar: function (event) {
      this.$router.push({ name: 'Editar Repertório', params: { repertorioid: this.repertorioid } })
    },
    deletar: function () {
      this.deleteConfirm = false
      db.collection('repertorio').where('codigo', '==', this.repertorioid).get().then(function (querySnapshot) {
        console.log(querySnapshot)
        querySnapshot.docs[0].ref.delete().then(function () {
          console.log('Document successfully deleted!')
          this.$router.push({ name: 'Repertório' })
        }.bind(this)).catch(function (error) {
          console.error('Error removing document: ', error)
        })
      }.bind(this))
    },
    openDrive: function () {
      window.open(this.repertorio.linkDrive)
    }
  },
  computed: {
  },
  mounted () {
    const queryResult = this.$store.state.repertorio.find(x => x.codigo === this.repertorioid)
    this.fail = false
    if (queryResult) {
      console.log('Binding Repertorio from store')
      // this.$unbind('repertorio')
      this.repertorio = queryResult
    } else {
      console.log('Binding Repertorio from database')
      this.$bind('boundquery', db.collection('repertorio').where('codigo', '==', this.repertorioid)).then(function () {
        console.log(this.boundquery)
        if (!this.boundquery.length) {
          this.fail = true
        } else {
          this.repertorio = this.boundquery[0]
        }
      }.bind(this))
    }
  }
}
</script>

<style scoped>
.container {
  max-width: 800px;
}

h1 {
  font-size: 2rem;
  margin-top: 5px;
  margin-bottom: 0px;
  color: black;
}

.label {
  font-size: 1rem;
  font-style: normal;
  margin-bottom: 0.25em;
}

.organizadorfield {
  font-size: 1.5rem;
}
.main-card {
  margin: auto;
  margin-top: 20px;
  padding-top: 10px;
  padding: 16px;
  color: black;
  background-color: white;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}

.title {
  margin-bottom: 20px;
}

.detalhefield {
  margin-top: 0.25rem;
  font-size: 1rem;
}

.descfield {
  margin-bottom: 20px;
  font-style: italic;
}

.adminoptions {
  background: #CCCCCC;
  margin-top: 20px;
  border-radius: 6px;
  padding: 10px;
}

.ul {
  margin-top: 5px;
}

.inviteoptions {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.refusebutton::v-deep {
  background: linear-gradient(0deg, #cc3333 0%, #ff5555 100%) !important;
  width: 100%;
  margin-top: 5px;
}

.acceptbutton::v-deep {
  width: 100%;
  margin-top: 10px;
}

.editbutton::v-deep {
  font-size: 1em;
  height: 2em;
  width: fit-content;
  padding-left: 10px;
  padding-right: 10px;
}
.editbutton {
  margin-top: 10px;
}

  /* Mobile Styles */
@media only screen and (max-width: 415px) {
  .main-card {
    width: 100%;
    margin-top: 0px;
  }
}

/* iphone XR */
@media only screen and (min-device-width : 414px) and (max-device-height : 896px) and (-webkit-device-pixel-ratio : 2) {
  .main-card {
    width: 100%;
    margin-top: 0px;
  }
}

/* Desktop Styles */
@media only screen and (min-width: 416px) {
  .main-card {
    max-width: 50%;
    -webkit-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 2px 2px 5px 0px rgba(0,0,0,0.75);
    border-radius:6px;
    -moz-border-radius:6px;
    -webkit-border-radius:6px;
    }
}
</style>
